// Web-Audio alerts for staff chat — no asset files. `ring()` is the loud, repeating
// alarm for a NEW chat request; `ding()` is the soft chime for follow-up messages.
let _ctx = null;
const ctx = () => {
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
};

const tone = (c, { freq, start, len, gain = 0.18, type = "sine" }) => {
  const now = c.currentTime;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, now + start);
  g.gain.linearRampToValueAtTime(gain, now + start + 0.012);
  g.gain.exponentialRampToValueAtTime(0.001, now + start + len);
  osc.connect(g).connect(c.destination);
  osc.start(now + start);
  osc.stop(now + start + len + 0.02);
};

export function ding() {
  try {
    const c = ctx();
    tone(c, { freq: 880, start: 0, len: 0.12 });
    tone(c, { freq: 1320, start: 0.06, len: 0.16 });
  } catch { /* audio blocked */ }
}

// Telephone-style ring: 3 bursts of a two-tone trill, ~2.4 s, loud.
export function ring() {
  try {
    const c = ctx();
    for (let burst = 0; burst < 3; burst++) {
      const b = burst * 0.85;
      for (let i = 0; i < 6; i++) {
        tone(c, { freq: i % 2 ? 1046 : 1318, start: b + i * 0.07, len: 0.09, gain: 0.6, type: "square" });
      }
      tone(c, { freq: 659, start: b, len: 0.45, gain: 0.25, type: "triangle" });
    }
  } catch { /* audio blocked */ }
}

export const SOUND_PREF_KEY = "kolt.chat.sound";
export const soundEnabled = () => { try { return localStorage.getItem(SOUND_PREF_KEY) !== "0"; } catch { return true; } };
